import { render, staticRenderFns } from "./withdrawscore.vue?vue&type=template&id=051b858e&scoped=true"
import script from "./withdrawscore.vue?vue&type=script&lang=js"
export * from "./withdrawscore.vue?vue&type=script&lang=js"
import style0 from "./withdrawscore.vue?vue&type=style&index=0&id=051b858e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051b858e",
  null
  
)

export default component.exports